import * as React from "react";
import { useRouter } from "@tanstack/react-router";

export default function Link({
  href,
  children,
  replace,
  ...props
}: React.PropsWithChildren<
  { href: string; replace?: boolean } & React.AnchorHTMLAttributes<HTMLAnchorElement>
>) {
  const router = useRouter();
  return (
    <a
      href={href}
      {...props}
      onClick={(event) => {
        if (event.defaultPrevented) return;
        if (event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (props.target && props.target !== "_self") return;
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        event.preventDefault();
        if (replace) router.history.replace(href);
        else router.history.push(href);
      }}
    >
      {children}
    </a>
  );
}
